import React, { useEffect, useState } from 'react';
import { getFullBalance } from '../../services/ExchangeService';

function pnlClass(pct) {
    if (pct > 0) return 'text-success fw-bold';
    if (pct < 0) return 'text-danger fw-bold';
    return 'text-muted';
}

/**
 * props:
 * - tickerData  { BTCUSDT: { close: 65000 }, ... }
 */
function OpenPositions({ tickerData }) {
    const [positions, setPositions] = useState([]);

    useEffect(() => {
        getFullBalance('USDT')
            .then(info => {
                const rows = Object.entries(info)
                    .filter(([coin, data]) => {
                        if (coin === 'fiatEstimate') return false;
                        const qty = parseFloat(data.available || 0) + parseFloat(data.onOrder || 0);
                        return qty > 0 && data.avg > 0 && coin !== 'USDT';
                    })
                    .map(([coin, data]) => ({
                        coin,
                        qty: parseFloat(data.available || 0) + parseFloat(data.onOrder || 0),
                        avg: parseFloat(data.avg),
                        // valor de mercado atual da posição (já calculado no backend via Redis).
                        // Serve de fonte REST do preço atual quando o ticker do WS não chega.
                        value: parseFloat(data.fiatEstimate)
                    }));
                setPositions(rows);
            })
            .catch(() => {});
    }, []);

    if (!positions.length) return null;

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <h6 className='mb-3'>Posições Abertas</h6>
            <div className='table-responsive'>
                <table className='table table-sm table-hover mb-0 align-middle'>
                    <thead>
                        <tr>
                            <th>Moeda</th>
                            <th className='text-end'>Quantidade</th>
                            <th className='text-end'>Preço Médio</th>
                            <th className='text-end'>Preço Atual</th>
                            <th className='text-end'>P&amp;L Não Realizado</th>
                            <th className='text-end'>Retorno</th>
                        </tr>
                    </thead>
                    <tbody>
                        {positions.map(p => {
                            // Preço atual: prefere o ticker do WS (tempo real); cai pro valor de
                            // mercado REST (fiatEstimate/qty) quando o WS não entrega — antes
                            // ficava tudo "—" na VPS, onde o stream de ticker é instável.
                            const ticker = tickerData && tickerData[p.coin + 'USDT'];
                            const liveCurrent = ticker ? parseFloat(ticker.close) : null;
                            const restCurrent = (p.value > 0 && p.qty > 0) ? p.value / p.qty : null;
                            const current = (liveCurrent && liveCurrent > 0) ? liveCurrent : restCurrent;
                            const pnl = current != null ? (current - p.avg) * p.qty : null;
                            const pct = current != null ? ((current - p.avg) / p.avg) * 100 : null;

                            return (
                                <tr key={p.coin}>
                                    <td><strong>{p.coin}</strong></td>
                                    <td className='text-end text-muted' style={{ fontSize: 13 }}>
                                        {p.qty.toFixed(6).replace(/\.?0+$/, '')}
                                    </td>
                                    <td className='text-end' style={{ fontSize: 13 }}>
                                        ${p.avg.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                    <td className='text-end' style={{ fontSize: 13 }}>
                                        {current != null
                                            ? `$${current.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                            : <span className='text-muted'>—</span>}
                                    </td>
                                    <td className={`text-end ${pnl != null ? pnlClass(pnl) : 'text-muted'}`} style={{ fontSize: 13 }}>
                                        {pnl != null
                                            ? `${pnl >= 0 ? '+' : ''}$${pnl.toFixed(2)}`
                                            : '—'}
                                    </td>
                                    <td className={`text-end ${pct != null ? pnlClass(pct) : 'text-muted'}`} style={{ fontSize: 13 }}>
                                        {pct != null
                                            ? `${pct >= 0 ? '+' : ''}${pct.toFixed(2)}%`
                                            : '—'}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <small className='text-muted mt-2'>
                Preço médio calculado sobre todas as compras registradas no sistema. Preço atual via stream de mercado.
            </small>
        </div>
    );
}

export default OpenPositions;
